import React, { useState } from 'react';
import { Container, Form, Button, Card, Row, Col, ProgressBar, Alert } from 'react-bootstrap';

interface QuizQuestion {
  question: string;
  options: string[];
}

const questions: QuizQuestion[] = [
  {
    question: 'Are any of your current windows drafty or leaking air?',
    options: ['Yes, several', 'A few', 'No drafts or leaks']
  },
  {
    question: 'Do you notice condensation or fog between window panes?',
    options: ['Frequently', 'Occasionally', 'Never']
  },
  {
    question: 'Are your windows hard to open, close, or lock?',
    options: ['Yes, very difficult', 'Somewhat difficult', 'No issues']
  },
  {
    question: 'How would you rate your monthly energy bills?',
    options: ['Too high', 'Average', 'Low']
  },
  {
    question: 'Do you feel a significant temperature difference near windows during extreme weather?',
    options: ['Yes', 'Somewhat', 'No']
  },
  {
    question: 'Are your windows ENERGY STAR® rated or double/triple pane?',
    options: ['No', 'Not sure', 'Yes']
  },
  {
    question: 'Do outside noises (traffic, neighbors, etc.) bother you inside your home?',
    options: ['Yes, a lot', 'Sometimes', 'No']
  },
  {
    question: 'Are your windows over 20 years old?',
    options: ['Yes', 'Close to 20', 'No']
  },
  {
    question: 'Are you interested in improving curb appeal or resale value?',
    options: ['Very important', 'Somewhat important', 'Not a priority']
  },
  {
    question: 'What’s your window replacement budget per window?',
    options: ['Under $300', '$300–$700', '$700+']
  },
  {
    question: 'How soon are you planning to replace your windows?',
    options: ['Within 1 month', '1–6 months', 'Just researching']
  }
];

const WindowScoreCardQuiz: React.FC = () => {
  const [answers, setAnswers] = useState<string[]>(Array(questions.length).fill(''));
  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] = useState(0);

  const handleChange = (index: number, value: string) => {
    const updatedAnswers = [...answers];
    updatedAnswers[index] = value;
    setAnswers(updatedAnswers);
  };

  const handleSubmit = () => {
    let total = 0;
    answers.forEach(answer => {
      if (answer === questions[0].options[0] || answer === questions[0].options[1]) {
        total += 1;
      }
    });
    setScore(total);
    setSubmitted(true);
  };

  const getRecommendation = () => {
    if (score >= 6) return '🚨 Strongly Consider Full Replacement';
    if (score >= 3) return '⚠️ Partial Replacement or Upgrades';
    return '👍 Your Windows Are Still in Good Shape';
  };

  return (
    <Container className="my-5">
      <h1 className="text-center mb-4">Window Score Card Quiz</h1>
      {!submitted ? (
        <Form>
          {questions.map((q, idx) => (
            <Card key={idx} className="mb-3">
              <Card.Body>
                <Card.Title>{q.question}</Card.Title>
                {q.options.map((opt, oIdx) => (
                  <Form.Check
                    type="radio"
                    key={oIdx}
                    name={`question-${idx}`}
                    label={opt}
                    checked={answers[idx] === opt}
                    onChange={() => handleChange(idx, opt)}
                  />
                ))}
              </Card.Body>
            </Card>
          ))}
          <div className="text-center">
            <Button variant="success" size="lg" onClick={handleSubmit}>Get My Window Score</Button>
          </div>
        </Form>
      ) : (
        <Alert variant="info" className="text-center">
          <h4>Your Score: {score} out of {questions.length}</h4>
          <p><strong>Recommendation:</strong> {getRecommendation()}</p>
          <Button variant="primary" onClick={() => window.location.reload()}>Start Over</Button>
        </Alert>
      )}
    </Container>
  );
};

export default WindowScoreCardQuiz;
